import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { getProduct } from "@/lib/api";
import WishlistButton from "@/components/WishlistButton";

const ProductDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [activeImg, setActiveImg] = useState(0);

  useEffect(() => {
    setProduct(null);
    setNotFound(false);
    setActiveImg(0);
    getProduct(slug)
      .then(setProduct)
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound)
    return (
      <div className="px-5 md:px-10 py-32 text-center" data-testid="product-not-found">
        <h1 className="font-serif text-4xl uppercase mb-4">Not Found</h1>
        <Link to="/shop" className="text-xs font-mono uppercase tracking-widest text-[#5B2A86]">
          Back to collections
        </Link>
      </div>
    );

  if (!product)
    return (
      <div className="px-5 md:px-10 py-32 font-mono text-xs uppercase tracking-widest text-muted-foreground">
        Loading…
      </div>
    );

  return (
    <div data-testid="product-detail-page" className="px-5 md:px-10 py-10">
      <button
        onClick={() => navigate(-1)}
        data-testid="back-button"
        className="flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground hover:text-foreground mb-8"
      >
        <ArrowLeft className="w-4 h-4" /> Back
      </button>

      <div className="max-w-4xl mx-auto">
        <div className="relative overflow-hidden bg-secondary">
          <img
            src={product.images[activeImg]}
            alt=""
            className="w-full h-auto max-h-[82vh] object-contain mx-auto"
            data-testid="product-main-image"
          />
          <div className="absolute top-4 right-4 z-10">
            <WishlistButton slug={product.slug} size="lg" />
          </div>
        </div>

        {product.images.length > 1 && (
          <div className="flex gap-3 mt-4 justify-center">
            {product.images.map((img, i) => (
              <button
                key={img}
                onClick={() => setActiveImg(i)}
                className={`w-20 aspect-[3/4] overflow-hidden border ${
                  activeImg === i ? "border-foreground" : "border-border"
                }`}
              >
                <img src={img} alt="" className="w-full h-full object-cover" />
              </button>
            ))}
          </div>
        )}

        <p className="text-center font-serif italic text-xl text-[#8a8a8a] mt-10 max-w-xl mx-auto">
          “{product.scripture}”
        </p>
      </div>
    </div>
  );
};

export default ProductDetail;
